import invAgo from './other/date/ago';
import invDate from './other/date';
import fileType from './other/file/file_type';
import camelcase from './string/camelcase';
import lowercase from './string/lowercase';
import placeholder from './string/placeholder';
import pluralize from './string/pluralize';
import prettyBytes from './other/file/pretty_bytes';
import replace from './string/replace';
import reverse from './string/reverse';
import titleCase from './string/titlecase';
import truncate from './string/truncate';
import uppercase from './string/uppercase';

export default (Vue) => {
    camelcase(Vue);
    invAgo(Vue);
    invDate(Vue);
    fileType(Vue);
    lowercase(Vue);
    placeholder(Vue);
    pluralize(Vue);
    prettyBytes(Vue);
    replace(Vue);
    reverse(Vue);
    titleCase(Vue);
    truncate(Vue);
    uppercase(Vue);
};